module.exports = __webpack_public_path__ + "static/target-07651482a7493e59cda5d9bc05c346a6.png";